import React from 'react'

class Preloader extends React.Component {

  render() {
    return (
      <section className="preloader">
        <div className="circle-3" />
        <div className="circle-2" />
        <div className="circle-1">
          <img
            className="logo"
            src="/kcell-white.svg"
            width="95px"
          />
        </div>
      </section>
    )
  }

}

export default Preloader